<div class="table-container">
  <table [dataSource]="dataSource" class="partner-details-table" mat-table>
    <ng-container matColumnDef="branchName">
      <th *matHeaderCellDef mat-header-cell>Branch Name</th>
      <td
        *matCellDef="let element; dataSource: dataSource"
        [copyValue]="asBranch(element).name || ''"
        mat-cell
      >
        {{ asBranch(element).name || "-" }}
      </td>
    </ng-container>

    <ng-container matColumnDef="address">
      <th *matHeaderCellDef mat-header-cell>Address</th>
      <td
        *matCellDef="let element; dataSource: dataSource"
        [copyValue]="asBranch(element).address || ''"
        mat-cell
      >
        {{ asBranch(element).address || "-" }}
      </td>
    </ng-container>

    <ng-container matColumnDef="postcode">
      <th *matHeaderCellDef mat-header-cell>Postcode</th>
      <td
        *matCellDef="let element; dataSource: dataSource"
        [copyValue]="asBranch(element).postcode || ''"
        mat-cell
      >
        {{ asBranch(element).postcode || "-" }}
      </td>
    </ng-container>

    <ng-container matColumnDef="state">
      <th *matHeaderCellDef mat-header-cell>State</th>
      <td
        *matCellDef="let element; dataSource: dataSource"
        [copyValue]="asBranch(element).state || ''"
        mat-cell
      >
        {{ asBranch(element).state || "-" }}
      </td>
    </ng-container>

    <ng-container matColumnDef="country">
      <th *matHeaderCellDef mat-header-cell>Country</th>
      <td
        *matCellDef="let element; dataSource: dataSource"
        [copyValue]="asBranch(element).country || ''"
        mat-cell
      >
        {{ asBranch(element).country || "-" }}
      </td>
    </ng-container>

    <ng-container matColumnDef="userName">
      <th *matHeaderCellDef mat-header-cell>Name</th>
      <td
        *matCellDef="let element; dataSource: dataSource"
        [copyValue]="asUser(element).name || ''"
        mat-cell
      >
        {{ asUser(element).name || "-" }}
      </td>
    </ng-container>

    <ng-container matColumnDef="branch">
      <th *matHeaderCellDef mat-header-cell>Branch</th>
      <td
        *matCellDef="let element; dataSource: dataSource"
        [copyValue]="asUser(element).branch || ''"
        mat-cell
      >
        {{ asUser(element).branch || "-" }}
      </td>
    </ng-container>

    <ng-container matColumnDef="email">
      <th *matHeaderCellDef mat-header-cell>Email Address</th>
      <td
        *matCellDef="let element; dataSource: dataSource"
        [copyValue]="asUser(element).email || ''"
        mat-cell
      >
        <span style="word-break: break-all">{{ asUser(element).email || "-" }}</span>
      </td>
    </ng-container>

    <ng-container matColumnDef="mobileNo">
      <th *matHeaderCellDef mat-header-cell>Mobile No.</th>
      <td
        *matCellDef="let element; dataSource: dataSource"
        [copyValue]="asUser(element).mobileNo || ''"
        mat-cell
      >
        {{ asUser(element).mobileNo || "-" }}
      </td>
    </ng-container>

    <ng-container matColumnDef="role">
      <th *matHeaderCellDef mat-header-cell>User Role</th>
      <td
        *matCellDef="let element; dataSource: dataSource"
        [copyValue]="asUser(element).role || ''"
        mat-cell
      >
        {{ asUser(element).role || "-" }}
      </td>
    </ng-container>

    <ng-container matColumnDef="type">
      <th *matHeaderCellDef mat-header-cell>Protection Type</th>
      <td
        *matCellDef="let element; dataSource: dataSource"
        [copyValue]="asProtection(element).type || ''"
        mat-cell
      >
        {{ asProtection(element).type || "-" }}
      </td>
    </ng-container>

    <ng-container matColumnDef="title">
      <th *matHeaderCellDef mat-header-cell>Title</th>
      <td
        *matCellDef="let element; dataSource: dataSource"
        [copyValue]="asProtection(element).title || ''"
        mat-cell
      >
        {{ asProtection(element).title || "-" }}
      </td>
    </ng-container>

    <ng-container matColumnDef="insurer">
      <th *matHeaderCellDef mat-header-cell>Insurer</th>
      <td
        *matCellDef="let element; dataSource: dataSource"
        [copyValue]="asProtection(element).insurer || ''"
        mat-cell
      >
        {{ asProtection(element).insurer || "-" }}
      </td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th *matHeaderCellDef mat-header-cell>Status</th>
      <td *matCellDef="let element; dataSource: dataSource" mat-cell>
        <span
          *ngIf="
            element.status === 'Active' ||
            element.status === PartnerStatus.Active
          "
          class="cover-label green"
          >Active</span
        >
        <span
          *ngIf="
            element.status === 'Pending' ||
            element.status === PartnerStatus.Pending
          "
          class="cover-label orange"
          >Pending Activation</span
        >
        <span
          *ngIf="
            element.status === 'Inactive' ||
            element.status === PartnerStatus.Inactive
          "
          class="cover-label grey"
          >Inactive</span
        >
      </td>
    </ng-container>

    <ng-container matColumnDef="actions" stickyEnd>
      <th *matHeaderCellDef mat-header-cell></th>
      <td *matCellDef="let element; dataSource: dataSource" mat-cell>
        <button [matMenuTriggerFor]="menu" mat-icon-button>
          <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
          <button (click)="edit(element)" mat-menu-item>
            <mat-icon>edit</mat-icon>
            <span>Edit Details</span>
          </button>
          <div *ngIf="config.id === TableConfigType.User">
            <button
              (click)="sendEmail(element)"
              [disabled]="element.status !== PartnerStatus.Pending"
              mat-menu-item
            >
              <mat-icon>email</mat-icon>
              <span>Send Email</span>
            </button>
          </div>
          <button (click)="delete(element)" class="delete-button" mat-menu-item>
            <mat-icon class="delete-icon">delete</mat-icon>
            <span class="delete-text">Delete</span>
          </button>
        </mat-menu>
      </td>
    </ng-container>

    <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
    <tr *matRowDef="let row; columns: displayedColumns" mat-row></tr>
  </table>
</div>

<mat-divider></mat-divider>

<mat-paginator
  #paginator
  (page)="pageChange($event)"
  [length]="config.length"
  [pageSizeOptions]="[10, 20, 50]"
  [pageSize]="config.limit"
></mat-paginator>
